import Typography from "@/components/foundation/typography"
import {
  Mission,
  MissionDuration,
  MissionStatus
} from "@/store/missions/models"
import classNames from "classnames"
import _ from "lodash"
import React from "react"
import style from "./style.scss"

interface MissionItemHeaderProps {
  mission: Mission
}

const MissionItemHeader: React.SFC<Readonly<MissionItemHeaderProps>> = (
  props
) => {
  const status = props.mission.getStatus()
  const duration = props.mission.getDuration()
  const remainingTasks = props.mission.getRemainingTasks()

  const getMissionDurationText = () => {
    const daysUntilMissionsEnds =
      props.mission.endDate && props.mission.getDaysUntilMissionsEnds()

    if (status === MissionStatus.QUOTA_FULL) {
      return "Quota Full"
    }

    if (duration === MissionDuration.NOT_STARTED) {
      return "Not Started"
    }

    if (duration === MissionDuration.ALWAYS_AVAILABLE) {
      return "Always Available"
    }

    if (duration === MissionDuration.FINISHED) {
      return "Finished"
    }

    if (daysUntilMissionsEnds === 1) {
      return `${daysUntilMissionsEnds} day`
    }

    return `${daysUntilMissionsEnds} days`
  }

  return (
    <header className={style.header}>
      {props.mission.title && (
        <Typography.H5 as="h1" className={style.title}>
          {props.mission.title}
        </Typography.H5>
      )}

      <div className={style.meta}>
        {props.mission.incentive !== null && (
          <div className={style.incentive}>
            ${props.mission.incentive}
            <span className={style.divider}>/</span>
          </div>
        )}

        <div
          className={classNames(
            style.duration,
            style[`duration--${_.kebabCase(duration)}`],
            style[`duration--${_.kebabCase(status)}`]
          )}
        >
          <Typography.P1>{getMissionDurationText()}</Typography.P1>
        </div>
      </div>

      <div className={style.tasks}>
        {remainingTasks > 0 && (
          <Typography.P2>
            {remainingTasks} {remainingTasks > 1 ? "tasks" : "task"}
            {status === MissionStatus.PENDING && " remaining"}
          </Typography.P2>
        )}
      </div>
    </header>
  )
}

export default MissionItemHeader
